import React, { ReactNode, useState } from "react";

import { hamburgerSvg, trashSvg } from "../assets/icons";
import { deleteWidget } from "../data/httpClient";
import { makeAccessibleClick } from "../utils/makeAccessibleClick";
import { notify } from "../utils/notify";
import { showConfirmToast } from "./ConfirmToast";

type CollapsibleContentProps = {
  title: string;
  children: ReactNode;
  widgetId: number;
};

const CollapsibleWidget: React.FC<CollapsibleContentProps> = ({
  title,
  children,
  widgetId,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const expandedClassName = isOpen ? "-expanded" : "";

  return (
    <div className="collapsible-widget-section">
      <div className="collapsible-widget-header">
        <div
          className="collapsible-widget-title"
          {...makeAccessibleClick(() => setIsOpen(!isOpen))}
          aria-label={`${isOpen ? "Collapse" : "Expand"} ${title}`}
          aria-expanded={isOpen}
        >
          <img
            className="collapsible-hamburger"
            src={hamburgerSvg}
            alt=""
            aria-hidden="true"
          />

          <span className="collapsible-widget-indicator" aria-hidden="true">
            {isOpen ? "▲" : "▼"}
          </span>
          <span>{title}</span>
        </div>

        <button
          className="collapsible-trashcan"
          onClick={async (e) => {
            e.stopPropagation();
            showConfirmToast({
              title: "Remove Widget",
              message: "Are you sure you want to delete this widget?",
              btnText: "Remove",
              onConfirm: async () => {
                await deleteWidget(widgetId);
                notify.persistToast({
                  message: "The widget was deleted successfully.",
                  type: "success",
                });
                window.location.reload();
              },
            });
          }}
          aria-label={`Delete ${title}`}
        >
          <img
            src={trashSvg}
            className="iconAction"
            alt=""
            aria-hidden="true"
          />
        </button>
      </div>
      <div className={`collapsible-widget-content${expandedClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default CollapsibleWidget;
